import React from 'react';
import SelectField from 'components/input/SelectField/SelectField';

const IntervalFilter = <SelectField
    choices={ [
        {
            id: 'day',
            name: 'filters.components.interval.choices.day',
        },
        {
            id: 'week',
            name: 'filters.components.interval.choices.week',
        },
        {
            id: 'month',
            name: 'filters.components.interval.choices.month',
        },
        {
            id: 'year',
            name: 'filters.components.interval.choices.year',
        },
    ] }
    floatingLabelFixed={ true }
    fullWidth={ true }
    label='filters.components.interval.label'
    source='interval'
/>;

export default IntervalFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/IntervalFilter.js